import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Ошибка отправки заявки',
  notAvailable: 'Данный регион недоступен для кредитования. Выберите другой финансовый продукт',
} satisfies TMessages
